import { useState, useEffect, forwardRef } from "react";

import styles from './DateInput.module.css';

interface DateInputProps {
    label: string;
    value: string;
    maxLength: number;
    nextRef?: React.RefObject<HTMLInputElement | null>;
    onCommit: (v: string) => void
}

export const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
    ({ label, value, maxLength, nextRef, onCommit }, ref) => {
        const [localVal, setLocalVal] = useState(value);

        useEffect(() => {
            setLocalVal(value);
        }, [value]);

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            let v = e.target.value.replace(/\D/g, '').slice(0, maxLength);

            if (label === 'day' && parseInt(v) > 31) v = '31';
            if (label === 'month' && parseInt(v) > 12) v = '12';

            setLocalVal(v);

            onCommit(v);

            if (v.length === maxLength) {
                setTimeout(() => {
                    nextRef?.current?.focus();
                    nextRef?.current?.select();
                }, 10);
            }
        };

        const handleBlur = () => {
            let v = localVal;

            if (v !== '') {
                const num = parseInt(v);
                if ((label === 'day' || label === 'month') && num === 0) {
                    v = '01';
                }
            }

            setLocalVal(v);
            onCommit(v);
        };
        return (
            <input
                ref={ref}
                data-date-input="true"
                type="text"
                inputMode="numeric"
                className={`${styles.input} ${styles[label]}`}
                value={localVal}
                onFocus={(e) => e.target.select()}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={(e) => e.key === 'Enter' && (e.target as HTMLInputElement).blur()}
            />
        );
    }
);